import React from 'react';

interface EditHeaderProps {
    mode: 'create' | 'edit';
}

const EditHeader: React.FC<EditHeaderProps> = ({ mode }) => {
    return (
        <div className="edit-header">
            <h2 className="edit-title">
                {mode === 'create' ? 'Nova Dica de Navegação' : 'Editar Dica de Navegação'}
            </h2>
        </div>
    );
};

export default EditHeader; 